import { Patterns } from "./patterns"

const WOFF = 'application/font-woff'
const JPEG = 'image/jpeg'
const mimes: { [key: string]: string } = {
  woff: WOFF,
  woff2: WOFF,
  ttf: 'application/font-truetype',
  eot: 'application/vnd.ms-fontobject',
  png: 'image/png',
  jpg: JPEG,
  jpeg: JPEG,
  gif: 'image/gif',
  tiff: 'image/tiff',
  svg: 'image/svg+xml',
  webp: 'image/webp',
}

export class MimesHelper {

  private constructor() {}

  static getExtension(url: string): string {
    const match = /\.([^./]*?)$/g.exec(url)
    return match ? match[1] : ''
  }

  static getMimeType(url: string): string {
    const extension = MimesHelper.getExtension(url).toLowerCase()
    return mimes[extension] || ''
  }

  static hasMimeType(url: string): boolean {
    return !!MimesHelper.getMimeType(url);
  }

  public static isSimpleDataUrl(data: string): boolean {
    return new RegExp(Patterns.SIMPLE_BASE64_DATA_URL_PATTERN).test(data ?? "");
}
}
